import React, { useState } from "react";
import "../../assets/css/UserForm.css";
function UserForm({ addUser, authUser, addAdmin }) {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "",
    status: "active",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setForm({
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      role: "",
      status: "active",
    });
    setIsModalOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.firstName || !form.lastName || !form.email || !form.status) {
      setError("Please fill out all fields.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      let response;
      if (form.role === "admin") {
        response = await addAdmin(form);
      } else {
        response = await addUser(form);
      }
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        role: "",
        status: "active",
      });

      closeModal();
    } catch (err) {
      if (err.message.includes("Email already exists")) {
        setError("This email is already registered. Please try another one.");
      } else {
        setError(err.message || "Error creating user. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <button onClick={openModal} className="open-modal-btn">
        Add User
      </button>
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Add New User</h2>
            <form className="user-form" onSubmit={handleSubmit}>
              <div className="input-container">
                <label htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  value={form.firstName}
                  onChange={(e) =>
                    setForm({ ...form, firstName: e.target.value })
                  }
                  required
                />
              </div>
              <div className="input-container">
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  value={form.lastName}
                  onChange={(e) =>
                    setForm({ ...form, lastName: e.target.value })
                  }
                  required
                />
              </div>
              <div className="input-container">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  autoComplete="new-email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  required
                />
              </div>
              <div className="input-container">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  autoComplete="new-password"
                  value={form.password}
                  onChange={(e) =>
                    setForm({ ...form, password: e.target.value })
                  }
                />
              </div>
              <div className="input-container">
                <label htmlFor="role">Role</label>
                <select
                  id="role"
                  value={form.role}
                  onChange={(e) => setForm({ ...form, role: e.target.value })}
                >
                  <option value="" disabled>
                    Select role
                  </option>
                  <option value="users" className="role-option user">
                    User
                  </option>
                  {authUser?.role === "superadmin" && (
                    <option value="admin" className="role-option admin">
                      Admin
                    </option>
                  )}
                </select>
              </div>
              <div className="input-container">
                <label htmlFor="status">Status</label>
                <select
                  id="status"
                  value={form.status}
                  onChange={(e) => setForm({ ...form, status: e.target.value })}
                >
                  <option value="active" className="status-option active">
                    Active
                  </option>
                  <option value="inactive" className="status-option inactive">
                    Inactive
                  </option>
                </select>
              </div>

              {error && <div className="error-message">{error}</div>}
              <div className="form-buttons">
                <button type="submit" className="user-form-button" disabled={loading}>
                  {loading ? "Adding User..." : "+ Add User"}
                </button>
                <button type="button" onClick={closeModal} className="cancel-button">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserForm;
